// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__2l7q1","dragIcon":"SortableItem_dragIcon__1j9M1","disabled":"SortableItem_disabled__17LvA"};